import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dCartData from "../Restaumatic.PromotionsEngine.Cart.CartData/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dPromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic$dPromotionsEngine$dPromotions$dPromotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
const mapAccumL = /* #__PURE__ */ Data$dTraversable.mapAccumL(Data$dTraversable.traversableArray);
const narrowRange = dictOrd => min => max => value => {
  if (dictOrd.compare(value)(min).tag === "LT") { return min; }
  if (dictOrd.compare(value)(max).tag === "GT") { return max; }
  return value;
};
const evaluateFreeby = v => v1 => {
  if (v.tag === "Nothing") { return {...v1, value: Data$dMaybe.Nothing}; }
  if (v.tag === "Just") { return {...v1, value: Data$dMaybe.$Maybe("Just", Data$dRecord.unsafeGet("productValue")(v._1))}; }
  $runtime.fail();
};
const evaluateActiveItem = dictEq => cartValue => evaluatedUnconditionally => {
  const inactive = {...evaluatedUnconditionally, active: false, value: Data$dMaybe.Nothing};
  if (evaluatedUnconditionally.promotion.conditions.tag === "CartPromotion") {
    if (evaluatedUnconditionally.promotion.conditions._1.tag === "CartValue") {
      if (cartValue >= evaluatedUnconditionally.promotion.conditions._1._1.minCartValue) { return evaluatedUnconditionally; }
      return inactive;
    }
    return evaluatedUnconditionally;
  }
  return evaluatedUnconditionally;
};
const evaluateDisabledPromotionalItem = dictEq => inputCartData => cartValue => item => (
  {accum: cartValue, value: evaluateActiveItem(dictEq)(cartValue)({...item, active: true, value: Data$dMaybe.Nothing})}
);
const calcValueOfProductDiscount = dictEq => inputCartData => discountEvaluator => discount => productItemKey => {
  const $0 = discountEvaluator(discount);
  const $1 = Restaumatic$dPromotionsEngine$dCart$dCartData.findProduct(dictEq)(inputCartData)(productItemKey);
  if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0($1._1.productPrice)); }
  return Data$dMaybe.Nothing;
};
const calcValueOfCartDiscount = inputCartData => discountEvaluator => discount => Data$dMaybe.$Maybe(
  "Just",
  discountEvaluator(discount)(Restaumatic$dPromotionsEngine$dCart$dCartData.sum(Data$dFunctor.arrayMap(x => x.productPrice)(inputCartData.productItems)))
);
const evaluateDiscount = dictEq => discountEvaluator => inputCartData => item => discount => (
  {
    ...item,
    value: (() => {
      if (item.assignment.tag === "AssignmentToProduct") { return calcValueOfProductDiscount(dictEq)(inputCartData)(discountEvaluator)(discount)(item.assignment._1); }
      if (item.assignment.tag === "AssignmentToCart") { return calcValueOfCartDiscount(inputCartData)(discountEvaluator)(discount); }
      return Data$dMaybe.Nothing;
    })()
  }
);
const calcPriceDiscountSmallerThanPrice = priceDiscount => price => {
  if (price <= priceDiscount) { return -price; }
  return -priceDiscount;
};
const evaluatePriceDiscount = dictEq => evaluateDiscount(dictEq)(calcPriceDiscountSmallerThanPrice);
const calcPriceDiscountNormalized = priceDiscount => price => {
  if (priceDiscount < 0) { return 0; }
  if (priceDiscount > price) { return -price; }
  return -priceDiscount;
};
const calcPercentageDiscount = percentageDiscount => price => Data$dMoney$dRounded.roundCents(-Data$dInt.toNumber((() => {
  if (percentageDiscount < -100) { return -100; }
  if (percentageDiscount > 100) { return 100; }
  return percentageDiscount;
})()) * 0.01 * (Data$dInt.toNumber(price) / 100.0) * 100.0);
const evaluatePercentageDiscount = dictEq => evaluateDiscount(dictEq)(calcPercentageDiscount);
const evaluateEnabledPromotionalItem = dictEq => inputCartData => cartValue => item => {
  const evaluated = evaluateActiveItem(dictEq)(cartValue)({
    ...(() => {
      if (item.promotion.prize.tag === "Freeby") {
        return evaluateFreeby(item.input.tag === "FreeProductInput"
          ? Restaumatic$dPromotionsEngine$dPromotions$dPromotion.findPromotionFreeby(item.input._1.selection)(item.promotion)
          : Data$dMaybe.Nothing)(item);
      }
      if (item.promotion.prize.tag === "PercentageDiscount") { return evaluateDiscount(dictEq)(calcPercentageDiscount)(inputCartData)(item)(item.promotion.prize._1); }
      if (item.promotion.prize.tag === "PriceDiscount") { return evaluateDiscount(dictEq)(calcPriceDiscountSmallerThanPrice)(inputCartData)(item)(item.promotion.prize._1); }
      if (item.promotion.prize.tag === "CouponValue") { return item; }
      if (item.promotion.prize.tag === "TextInformation") { return {...item, value: Data$dMaybe.Nothing}; }
      $runtime.fail();
    })(),
    active: true
  });
  return {
    accum: (() => {
      if (evaluated.value.tag === "Nothing") { return cartValue + 0 | 0; }
      if (evaluated.value.tag === "Just") { return cartValue + evaluated.value._1 | 0; }
      $runtime.fail();
    })(),
    value: evaluated
  };
};
const evaluatePromotionalItem = dictEq => inputCartData => cartValue => item => {
  if (item.selection.tag === "UserEnabled" || item.selection.tag === "AutoEnabled") { return evaluateEnabledPromotionalItem(dictEq)(inputCartData)(cartValue)(item); }
  return {accum: cartValue, value: evaluateActiveItem(dictEq)(cartValue)({...item, active: true, value: Data$dMaybe.Nothing})};
};
const evaluateEnabledPromotionalItems = dictEq => {
  const compare = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.ordPromotionalItem(dictEq).compare;
  return inputCartData => items => Data$dArray.sortWith(Data$dOrd.ordInt)(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.promotionalItemId)(mapAccumL(evaluatePromotionalItem(dictEq)(inputCartData))(Restaumatic$dPromotionsEngine$dCart$dCartData.sum(Data$dFunctor.arrayMap(x => x.productPrice)(inputCartData.productItems)))(Data$dArray.sortBy(compare)(items)).value);
};
export {
  calcPercentageDiscount,
  calcPriceDiscountNormalized,
  calcPriceDiscountSmallerThanPrice,
  calcValueOfCartDiscount,
  calcValueOfProductDiscount,
  evaluateActiveItem,
  evaluateDisabledPromotionalItem,
  evaluateDiscount,
  evaluateEnabledPromotionalItem,
  evaluateEnabledPromotionalItems,
  evaluateFreeby,
  evaluatePercentageDiscount,
  evaluatePriceDiscount,
  evaluatePromotionalItem,
  mapAccumL,
  narrowRange
};
